/**
 * Date-range filter: a preset dropdown plus custom from/to inputs.
 * Shared by the finance list pages so their ranges behave identically.
 */

import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { getDatePreset, DATE_PRESET_OPTIONS, type DatePreset } from '@/lib/date-presets';

export function DateRangeFilter({
  preset,
  dateFrom,
  dateTo,
  onChange,
  className,
}: {
  preset: DatePreset;
  dateFrom: string;
  dateTo: string;
  onChange: (next: { preset: DatePreset; dateFrom: string; dateTo: string }) => void;
  className?: string;
}) {
  const handlePreset = (value: string) => {
    const next = value as DatePreset;
    if (next === 'custom') {
      onChange({ preset: next, dateFrom, dateTo });
      return;
    }
    const { from, to } = getDatePreset(next);
    onChange({ preset: next, dateFrom: from, dateTo: to });
  };

  return (
    <div className={`flex items-center gap-2 ${className || ''}`}>
      <Select value={preset} onValueChange={handlePreset}>
        <SelectTrigger className="w-36">
          <SelectValue placeholder="Time period" />
        </SelectTrigger>
        <SelectContent>
          {DATE_PRESET_OPTIONS.map(o => (
            <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {preset === 'custom' && (
        <>
          <Input
            type="date"
            className="w-40"
            value={dateFrom}
            onChange={(e) => onChange({ preset, dateFrom: e.target.value, dateTo })}
          />
          <Input
            type="date"
            className="w-40"
            value={dateTo}
            onChange={(e) => onChange({ preset, dateFrom, dateTo: e.target.value })}
          />
        </>
      )}
    </div>
  );
}
